import { useEffect, useMemo, useState } from 'react';
import { GridRowId } from '@mui/x-data-grid-pro';
import { Device } from '@src/types/Device';
import { sortAlphaNum } from '@utils/sortAlphaNum';

export default function useExpandedRows(
  devices: Device[] | undefined,
  maxInitialExpanded = 6,
): { expandedRowIds: GridRowId[] } {
  const initialExpandedIds = useMemo(() => {
    if (!devices || devices.length === 0) {
      return [];
    }

    return sortAlphaNum(devices, 'name')
      .slice(0, maxInitialExpanded)
      .map((device) => device.engineeringId);
  }, [devices, maxInitialExpanded]);

  const [expandedRowIds, setExpandedRowIds] =
    useState<GridRowId[]>(initialExpandedIds);

  useEffect(() => {
    setExpandedRowIds(initialExpandedIds);
  }, [initialExpandedIds]);

  return { expandedRowIds };
}
